'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpandIconIcon = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../lib/Icon');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExpandIconIcon = exports.ExpandIconIcon = function ExpandIconIcon(props) {
  var _prepareProps = (0, _Icon.prepareProps)(props),
      title = _prepareProps.title,
      iconProps = _prepareProps.iconProps;

  return _react2.default.createElement(
    'svg',
    (0, _extends3.default)({ width: '24', height: '24', viewBox: '0 0 24 24', focusable: 'false' }, iconProps, { 'aria-labelledby': 'title-wixcf0p' }),
    _react2.default.createElement(
      'title',
      { id: 'title-wixcf0p' },
      title
    ),
    _react2.default.createElement('path', { d: 'M9.211 10.24a.502.502 0 0 0-.7.142l-.27.403a.503.503 0 0 0 .136.701l3.206 2.137c.23.154.601.156.834 0l3.206-2.137a.5.5 0 0 0 .135-.7l-.268-.404a.509.509 0 0 0-.701-.142l-2.37 1.579a.822.822 0 0 1-.838 0l-2.37-1.58z', fill: 'currentColor', fillRule: 'evenodd', role: 'presentation' })
  );
};
exports.default = (0, _Icon.iconConstructor)('ExpandIcon', ExpandIconIcon);


//////////////////
// WEBPACK FOOTER
// ./~/@atlaskit/icon/glyph/expand.js
// module id = 354
// module chunks = 0